<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  font-family: "微软雅黑";
}
ul,
li {
  list-style: none;
}
.mrt20 {
  margin-top: 20px;
}
.bookMain {
  width: 100%;
  height: 550px;
  background: #f1f0f0;
  padding: 0px 40px 0px 10px;
  display: flex;
  .buyLeft {
    flex: 2;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    .leftMes {
      padding: 25px;
      width: 100%;
      height: 100%;
      ul {
        width: 100%;
        height: 100%;
        li {
          height: 33.33%;
          display: flex;
          padding: 10px 0px;
        }
        .autoLearn {
          display: flex;
          .left {
            flex: 2;
            padding: 20px;
            color: #040506;
            .study {
              height: 10px;
              line-height: 10px;
              font-size: 20px;
              padding-left: 5px;
              color: #000;
              border-left: 2px solid #db5647;
            }
          }
          .right {
            flex: 1;
            .rightImg {
              width: 100%;
              height: 100%;
              display: block;
            }
          }
        }
        .accompanyStudy {
          .left {
            flex: 1;
            padding: 20px;
            color: #040506;
            .leftImg {
              width: 100%;
              height: 100%;
              display: block;
            }
          }
          .right {
            flex: 2;
            text-align: right;
            border-top: 2px solid #f7f5f0;
            padding: 20px;
            color: #040506;
            .study {
              padding-right: 10px;
              margin-right: 10px;
              height: 10px;
              line-height: 10px;
              font-size: 20px;
              border-right: 2px solid #db5647;
              color: #000;
            }
          }
        }
        .evaluation {
          .left {
            flex: 2;
            padding: 20px;
            color: #040506;
            border-top: 2px solid #f7f5f0;
            .study {
              height: 10px;
              line-height: 10px;
              font-size: 20px;
              padding-left: 5px;
              border-left: 2px solid #db5647;
              color: #000;
            }
          }
          .right {
            flex: 1;
            .rightImg {
              width: 100%;
              height: 100%;
              display: block;
            }
          }
        }
      }
    }
  }
    .buyRight{
        flex: 1;
        height:100%;
        background-color:#f1f0f0;
        margin-left: 20px;
        .content{
            width: 100%;
            background-color: #fff;
            border-radius: 12px;
            padding: 25px 0px;
            .bookName{
                width: 100%;
                text-align: center;
                padding-top: 25px;
                color:#040506;
                font-size: 32px;
                font-weight: normal;
            }
            .bookGrade{
                color: #bdb6b4;
                width: 100%;
                text-align: center;
                font-size: 18px;
                padding-top: 10px;
            }
            .moneyNum{
                width: 100%;
                text-align: center;
                padding-top: 5px;
                .num{
                    font-size: 32px;
                    font-weight: normal;
                    line-height: 60px;
                    letter-spacing: 0px;
                    color: #db5647;
                }
                .year{
                    color: #bdb6b4;
                    font-size: 18px;
                }
            }
            .buyButton{
                width: 200px;
                height: 40px;
                margin:20px auto;
                text-align: center;
                background-image: linear-gradient(47deg,
                    #ff9a4a 0%,
                    #ffdf5d 100%);
                border-radius: 12px;
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 40px;
                letter-spacing: 0px;
                color: #ffffff;
                cursor: pointer;
            }
            .disOrder{
                padding: 50px 20px;
                text-align: center;
                font-size: 20px;
                color: @primary-color;
            }
        }
    }
}
</style>
<template>
  <div class="bookMain">
    <div class="buyLeft">
      <div class="leftMes">
        <ul>
          <li class="autoLearn">
            <div class="left">
              <div class="study">自主学习</div>
              <p class="mrt20">学习资源极其丰富，结合自身学习偏好，灵活选择学习任务和学习活动。</p>
            </div>
            <div class="right">
              <img class="rightImg"
                   src="../../assets/imgs/01.png"
                   alt="" />
            </div>
          </li>
          <li class="accompanyStudy">
            <div class="left">
              <img class="leftImg"
                   src="../../assets/imgs/02.png"
                   alt="" />
            </div>
            <div class="right">
              <div class="study">陪伴助学</div>
              <p class="mrt20">专家团队全程保驾护航，为学习者解疑答惑。</p>
            </div>
          </li>
          <li class="evaluation">
            <div class="left">
              <div class="study">综合评价</div>
              <p class="mrt20">系统提供图表等可视化形式，清晰展现学习者学习之旅的收获。</p>
            </div>
            <div class="right">
              <img class="rightImg"
                    src="../../assets/imgs/03.png"
                    alt="" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="buyRight">
        <div v-if="payUrl" class="content">
            <div class="bookName">
                {{product.name}}
            </div>
            <div class="bookGrade">
                {{product.info}}
            </div>
            <div class="moneyNum">
                <span v-if="product.price" class="num">¥ {{product.price.toFixed(2)}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="year">/年</span>
            </div>
            <div class="buyButton" @click="pay">
                立即支付
            </div>
        </div>
        <div v-else  class="content">
            <div class="disOrder">
                <p>订单无效</p>请重新生成订单！
            </div>
            <div class="buyButton" @click="back">
                返回
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// import contactsPeople from './Contacts'
export default {
  name: 'Class',
  components: {
    // contactsPeople
  },
  data () {
    return {
      price: '',
      payForm: '',
      product: {},
      payUrl: ''
    }
  },
  watch:{
  },
  mounted () {
    this.product = this.$route.params.product
    this.payUrl = this.$route.params.payUrl
  },
  methods: {
  pay () {
      // window._czc.push(['_trackEvent', '个人中心', '去支付'])
      // window.location.href = this.payUrl
      window.open(this.payUrl)
    },
    back () {
      // window._czc.push(['_trackEvent', '个人中心', '从支付页返回'])
      this.$router.push({ name: 'MyBooks' })
    }
  }
}
</script>
